/***************************************************************
5/23/2017
Alexander Self
add_work_table.js
- Table that maintains a list of work performed;
  work added from secontaryTS
***************************************************************/
import React from 'react';

import { totalHours } from '../../../utils';

const GangWorkTable = ({ work, removeWork, editWork }) => {
  return (
    <table className="bordered highlight responsive-table centered">
      <thead>
        <tr>
          <th>Work</th>
          <th>Hours</th>
          <th>Cost Center</th>
          <th>Sub Account</th>
          <th>Field</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          work.map((w, i) => (
            <tr key={`${w.workPerformed}${i}`}>
              <td>{ w.workPerformed }</td>
              <td>{ w.hours }</td>
              <td>{ w.costCenterCode }</td>
              <td>{ w.subAccount }</td>
              <td>{ w.field }</td>
              <td>
                <button onClick={() => editWork(w)} className="btn-floating waves-effect waves-light blue">
                  <i className="material-icons">mode_edit</i>
                </button>
              </td>
              <td>
                <button onClick={() => removeWork(w.workId)} className="btn-floating waves-effect waves-light red">
                  <i className="material-icons">clear</i>
                </button>
              </td>
            </tr>
          ))
        }
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td><center>Total Hours</center></td>
          <td><b><center>{ totalHours(work) }</center></b></td>
        </tr>
      </tfoot>
    </table>
  )
};

export default GangWorkTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/gang_work_table.js